<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let active = false;
	export let hover = false;
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 26.002 26.002">
	<g>
		<g>
			<path
				class:active
				class:hover
				d="M68.528 152.979h-.808a10.08 10.08 0 0 0-1.364-3.294l.572-.567a2.165 2.165 0 0 0 0-3.053l-.1-.1a2.156 2.156 0 0 0-3.053 0l-.572.566a10.236 10.236 0 0 0-3.289-1.364v-.8a2.165 2.165 0 0 0-2.161-2.161h-.136a2.165 2.165 0 0 0-2.161 2.161v.8a10.312 10.312 0 0 0-3.294 1.364l-.566-.566a2.156 2.156 0 0 0-3.053 0l-.1.1a2.156 2.156 0 0 0 0 3.053l.567.567a10.312 10.312 0 0 0-1.364 3.294h-.8a2.16 2.16 0 0 0-2.161 2.156v.142a2.165 2.165 0 0 0 2.161 2.161h.8a10.284 10.284 0 0 0 1.364 3.289l-.567.567a2.159 2.159 0 0 0 0 3.058l.1.1a2.166 2.166 0 0 0 3.053 0l.566-.572a10.08 10.08 0 0 0 3.294 1.364v.8a2.165 2.165 0 0 0 2.161 2.161h.136a2.165 2.165 0 0 0 2.161-2.161v-.8a10.006 10.006 0 0 0 3.289-1.364l.572.572a2.166 2.166 0 0 0 3.053 0l.1-.1a2.172 2.172 0 0 0 0-3.058l-.572-.567a10.053 10.053 0 0 0 1.364-3.289h.808a2.16 2.16 0 0 0 2.156-2.161v-.142a2.156 2.156 0 0 0-2.156-2.156zm1.107 2.3a1.111 1.111 0 0 1-1.107 1.112H67.29a.523.523 0 0 0-.514.43 9.1 9.1 0 0 1-1.521 3.672.532.532 0 0 0 .058.677l.871.871a1.1 1.1 0 0 1 0 1.568l-.094.1a1.111 1.111 0 0 1-1.574 0l-.871-.871a.519.519 0 0 0-.671-.058 9.24 9.24 0 0 1-3.674 1.52.523.523 0 0 0-.435.514v1.233a1.113 1.113 0 0 1-1.112 1.112h-.136a1.113 1.113 0 0 1-1.112-1.112v-1.233a.523.523 0 0 0-.435-.514 9.208 9.208 0 0 1-3.672-1.521.483.483 0 0 0-.3-.094.507.507 0 0 0-.372.152l-.871.871a1.111 1.111 0 0 1-1.574 0l-.1-.1a1.108 1.108 0 0 1 0-1.568l.876-.871a.532.532 0 0 0 .058-.677 9.1 9.1 0 0 1-1.521-3.672.523.523 0 0 0-.514-.43h-1.237a1.113 1.113 0 0 1-1.112-1.112v-.142a1.111 1.111 0 0 1 1.112-1.107h1.238a.523.523 0 0 0 .514-.435 9.134 9.134 0 0 1 1.521-3.672.525.525 0 0 0-.058-.671l-.876-.871a1.121 1.121 0 0 1 0-1.574l.1-.1a1.121 1.121 0 0 1 1.574 0l.871.876a.525.525 0 0 0 .671.058 9.06 9.06 0 0 1 3.672-1.521.529.529 0 0 0 .435-.519v-1.233a1.113 1.113 0 0 1 1.112-1.112h.136a1.113 1.113 0 0 1 1.112 1.112v1.233a.528.528 0 0 0 .435.519 9.091 9.091 0 0 1 3.672 1.521.526.526 0 0 0 .671-.058l.871-.876a1.121 1.121 0 0 1 1.574 0l.094.1a1.111 1.111 0 0 1 0 1.574l-.871.871a.525.525 0 0 0-.058.671 9.134 9.134 0 0 1 1.521 3.672.523.523 0 0 0 .514.435h1.238a1.11 1.11 0 0 1 1.107 1.107z"
				transform="translate(-44.682 -142.205)" />
		</g>
		<g transform="translate(7.115 7.114)">
			<circle cx="5.888" cy="5.888" r="5.888" class:active class:hover />
		</g>
	</g>
</svg>

<style lang="scss">
	path,
	circle {
		transition: all 0.5s;
		fill: #bcbfc3;

		&.hover {
			fill: var(--default-hover-btn-1);
		}

		&.active {
			fill: var(--signature-blue) !important;
		}
	}

</style>
